import { render } from "./UnicomRequests.vue?vue&type=template&id=2dc63c80"
import script from "./UnicomRequests.vue?vue&type=script&lang=js"
export * from "./UnicomRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__